import React from 'react';
import propTypes from 'prop-types';
export const JalaliIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 72 72"
      // enable-background="new 0 0 72 72"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M36.564,14.645c-11.671,0-21.167,9.495-21.167,21.166c0,11.671,9.495,21.166,21.167,21.166
     c11.672,0,21.168-9.494,21.168-21.166C57.732,24.14,48.236,14.645,36.564,14.645z M36.564,52.979
     c-9.465,0-17.167-7.701-17.167-17.167c0-9.466,7.701-17.166,17.167-17.166c9.467,0,17.168,7.7,17.168,17.166
     C53.732,45.279,46.031,52.979,36.564,52.979z"
        />
        <path
          d="M34.666,22.306c-4.054,0-7.859,2.167-9.929,5.655c-0.281,0.475-0.125,1.089,0.35,1.371c0.16,0.095,0.336,0.14,0.51,0.14
     c0.341,0,0.674-0.175,0.861-0.489c1.711-2.885,4.856-4.677,8.208-4.677c0.553,0,1-0.447,1-1
     C35.666,22.753,35.219,22.306,34.666,22.306z"
        />
        <path
          d="M24.631,30.464c-0.529-0.123-1.076,0.207-1.202,0.745c-0.195,0.826-0.304,1.337-0.304,2.27c0,0.553,0.447,1,1,1
     s1-0.447,1-1c0-0.716,0.077-1.073,0.251-1.813C25.502,31.129,25.169,30.591,24.631,30.464z"
        />
        <path d="M37.37,59.5c-1.104,0-2,0.895-2,2v6c0,1.104,0.896,2,2,2c1.104,0,2-0.896,2-2v-6C39.37,60.395,38.475,59.5,37.37,59.5z" />
        <path d="M37.37,12.5c1.104,0,2-0.896,2-2v-6c0-1.104-0.896-2-2-2c-1.104,0-2,0.896-2,2v6C35.37,11.604,36.266,12.5,37.37,12.5z" />
        <path
          d="M17.055,52.428l-4.242,4.242c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586
     c0.511,0,1.023-0.195,1.414-0.586l4.242-4.242c0.781-0.781,0.781-2.047,0-2.828C19.102,51.646,17.836,51.646,17.055,52.428z"
        />
        <path
          d="M54.531,19.78c0.512,0,1.023-0.195,1.414-0.586l4.242-4.242c0.78-0.781,0.78-2.047,0-2.828
     c-0.781-0.781-2.047-0.781-2.828,0l-4.242,4.242c-0.781,0.781-0.781,2.047,0,2.828C53.508,19.585,54.02,19.78,54.531,19.78z"
        />
        <path
          d="M17.055,19.194c0.391,0.391,0.902,0.586,1.414,0.586c0.511,0,1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828
     l-4.242-4.242c-0.781-0.781-2.047-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828L17.055,19.194z"
        />
        <path
          d="M55.945,52.428c-0.781-0.781-2.047-0.781-2.828,0s-0.781,2.047,0,2.828l4.242,4.244c0.391,0.391,0.902,0.586,1.414,0.586
     s1.023-0.195,1.414-0.586c0.78-0.781,0.78-2.047,0-2.828L55.945,52.428z"
        />
        <path d="M10.5,34.5h-6c-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h6c1.104,0,2-0.896,2-2C12.5,35.396,11.604,34.5,10.5,34.5z" />
        <path d="M67.5,34.5h-6c-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h6c1.104,0,2-0.896,2-2C69.5,35.396,68.604,34.5,67.5,34.5z" />
      </g>
    </svg>
  );
};
JalaliIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
JalaliIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
